// Пользовательские настройки голоса (сохраняются между заходами).
//   speed     — скорость речи (множитель, ~0.7..1.6).
//   ttsEngine — движок озвучки: piper (разные голоса) | edge (Microsoft) | browser (Siri).
//   ambient   — характер фонового звука, пока агент думает (см. AMBIENT_OPTIONS).

export type TtsEngine = 'piper' | 'edge' | 'browser' | 'openai'
export type SttEngine = 'browser' | 'whisper'
export type AmbientId = 'drone' | 'sonar' | 'shimmer' | 'tape' | 'water' | 'pulse'

const SPEED_KEY = 'clawapp:speed'
const TTS_KEY = 'clawapp:ttsEngine'
const STT_KEY = 'clawapp:sttEngine'
const AMBIENT_KEY = 'clawapp:ambient'

// Метаданные вариантов фонового звука (для панели настроек). Порядок = в UI.
export const AMBIENT_OPTIONS: Array<{ key: AmbientId; label: string; hint: string }> = [
  { key: 'pulse', label: 'Пульс', hint: 'тёплый дрон с медленным пульсом — «идёт работа»' },
  { key: 'drone', label: 'Дыхание', hint: 'тёплый пэд, медленно «дышит» — спокойный' },
  { key: 'sonar', label: 'Сонар', hint: 'низкий гул и редкий мягкий пинг — «ищет»' },
  { key: 'shimmer', label: 'Мерцание', hint: 'переливы поверх фона — AI-эстетика' },
  { key: 'tape', label: 'Тепло', hint: 'аналоговый «воздух» — уютный, ламповый' },
  { key: 'water', label: 'Природа', hint: 'размытые вода и ветер — самый спокойный' },
]

const AMBIENT_IDS = AMBIENT_OPTIONS.map((o) => o.key)

export function getAmbient(): AmbientId {
  try {
    const v = localStorage.getItem(AMBIENT_KEY) as AmbientId | null
    return v && AMBIENT_IDS.includes(v) ? v : 'pulse'
  } catch {
    return 'pulse'
  }
}

export function setAmbient(v: AmbientId): void {
  try {
    localStorage.setItem(AMBIENT_KEY, v)
  } catch {
    /* noop */
  }
}

export function getStt(): SttEngine {
  try {
    return localStorage.getItem(STT_KEY) === 'whisper' ? 'whisper' : 'browser'
  } catch {
    return 'browser'
  }
}

export function setStt(e: SttEngine): void {
  try {
    localStorage.setItem(STT_KEY, e)
  } catch {
    /* noop */
  }
}

export function getSpeed(): number {
  try {
    const v = Number(localStorage.getItem(SPEED_KEY))
    return Number.isFinite(v) && v >= 0.5 && v <= 2 ? v : 1.25
  } catch {
    return 1.25
  }
}

export function setSpeed(v: number): void {
  try {
    localStorage.setItem(SPEED_KEY, String(v))
  } catch {
    /* noop */
  }
}

export function getTtsEngine(): TtsEngine {
  try {
    const v = localStorage.getItem(TTS_KEY)
    return v === 'edge' || v === 'browser' || v === 'openai' ? v : 'piper'
  } catch {
    return 'piper'
  }
}

export function setTtsEngine(e: TtsEngine): void {
  try {
    localStorage.setItem(TTS_KEY, e)
  } catch {
    /* noop */
  }
}
